<template>
  <v-col cols="12">
    <v-row no-gutters>
      <v-col
        cols="12"
        class="sz-red-background pt-5"
      >
        <SliderComponent
          :items="quotesSlider"
          class="mb-9 mx-2"
          :title="$t('home.quotesSlider.title')"
          content-center
        >
          <template #default="{ item, toggle }">
            <v-sheet
              width="350"
              elevation="4"
              rounded
              color="white"
              class="pa-5 pb-3 sz-primary-grey--text font-weight-medium mx-3 d-md-block"
              @click="toggle"
            >
              <v-icon
                :size="24"
                class="mb-3"
              >
                $quote
              </v-icon>
              <p
                v-if="item?.title"
                class="f-20 sz-primary-red--text"
              >
                {{ item.title }}
              </p>
              <p
                v-if="item?.quote"
                v-orphans
                class="f-16"
                v-html="item.quote"
              />
            </v-sheet>
          </template>
        </SliderComponent>
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup lang="ts">
import SliderComponent from '@/components/widgets/SliderSheet/SliderComponent.vue';
import { QUOTES_SLIDER } from '@/constants/slider';
import type { QuotesSlider } from '@/types';
import { ref } from 'vue';

const quotesSlider = ref<QuotesSlider[]>(QUOTES_SLIDER);
</script>
